<!-- Gedeelde filter-legende: elk item is legende (kleur + label) én filter
     (vinkje) tegelijk; de knop achteraan (de)selecteert alles. -->
<ul class="transit-legend-filter">
  @for (item of legendItems(); track item.category) {
    <li>
      <label
        class="transit-legend-filter__item"
        [class.is-disabled]="!item.enabled"
      >
        <input
          type="checkbox"
          class="transit-legend-filter__check"
          [checked]="item.enabled"
          [attr.aria-label]="t('filterCategoryAria', { category: item.label })"
          (change)="toggleLegendCategory(item.category)"
        />
        <span
          class="transit-legend-filter__dot"
          [style.background-color]="item.color"
          [style.border-color]="item.color"
          aria-hidden="true"
        ></span>
        <span>{{ item.label }}</span>
      </label>
    </li>
  }
  <li class="transit-legend-filter__all">
    <button
      eBtn
      class="transit-legend-filter__all-btn"
      size="xs"
      squared
      type="button"
      color="highlight"
      [icon]="toggleAllIcon()"
      [tooltip]="t(toggleAllLabelKey())"
      [attr.aria-label]="t(toggleAllLabelKey())"
      (click)="toggleAllCategories()"
    ></button>
  </li>
</ul>
